export default __webpack_public_path__ + "static/media/maes_coverphoto.1fe85208.png";